import { api } from "@/lib/api";

const KEY = "rc_visitor_id";
let sent = false;

function visitorId() {
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto.randomUUID?.() ?? `${Date.now()}-${Math.random().toString(36).slice(2)}`).replace(/[^a-zA-Z0-9-]/g, "");
    localStorage.setItem(KEY, id);
  }
  return id;
}

export function trackVisit() {
  if (sent) return;
  sent = true;
  try {
    api.post("/track", { path: window.location.pathname || "/", visitor_id: visitorId(), referrer: document.referrer || "" }).catch(() => {});
  } catch (e) {
    /* tracking must never break the page */
  }
}
